var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn form-check-label waves-effect waves-light mr-3 mb-3",class:[
    _vm.buttonClass,
    {
      'recommend-btn': _vm.buttonType == 'round',
      'active': _vm.clicked,
      'text-wrap': _vm.isWrap
    }
  ],attrs:{"for":_vm.buttonId},on:{"click":_vm.selectEvent}},[(_vm.buttonType == 'round')?_c('div',{staticClass:"content"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.postName},domProps:{"value":_vm.buttonValue,"checked":_vm.clicked}}),_vm._v("\n    "+_vm._s(_vm.buttonLabel)+"\n  ")]):_c('div',[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.postName},domProps:{"value":_vm.buttonValue,"checked":_vm.clicked}}),_vm._v("\n    "+_vm._s(_vm.buttonLabel)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }